import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';
import { 
  ARMOR_TYPES, 
  LANGUAGES, 
  SENSES, 
  SKILLS, 
  WEAPON_KEYWORDS 
} from "@dndModels";
import { 
  ModelBase
} from "@models";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import LoadingBox from "@components/input/LoadingBox";
import { DataType } from '@dndModels/Types';

interface Props {
  ids: string[];
  type?: DataType | "";
  types?: DataType[];
  display_field?: string;
  display_type?: boolean;
  log_it?: boolean;
  display_image?: boolean;
  onClick?: ((obj: ModelBase) => void) | null;
}

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function DisplayObjects({
  ids,
  type = "",
  types = [],
  display_field = "name",
  display_type = false,
  log_it = false,
  display_image = false,
  onClick
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [objects, setObjects] = useState<ModelBase[]>([]);
  const [width, setWidth] = useState(-1);

  const widthFinder: any = React.createRef();

   
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const load = () => {
    if (widthFinder && widthFinder.current instanceof HTMLElement) {
      setWidth(widthFinder.current.offsetWidth);
    }
    if (type !== "") {
      if (type === "armor_type") {
        setObjects(ARMOR_TYPES);
      } else if (type === "language") {
        setObjects(LANGUAGES);
      } else if (type === "sense") {
        setObjects(SENSES);
      } else if (type === "skill") {
        setObjects(SKILLS);
      } else if (type === "weapon_keyword") {
        setObjects(WEAPON_KEYWORDS);
      } else {
        setLoading(true);
        api.getObjects({ data_type: type }).then(res => {
          if (log_it) {
            debugger;
          }
          setObjects(res as ModelBase[]);
          setLoading(false);
        });
      }
    } else if (types.length > 0) {
      if (log_it) {
        debugger;
      }
      setLoading(true);
      let data_types = types;
      const extra_objects: ModelBase[] = [];
      if (data_types.includes("armor_type")) {
        extra_objects.push(...ARMOR_TYPES);
      }
      if (data_types.includes("language")) {
        extra_objects.push(...LANGUAGES);
      }
      if (data_types.includes("sense")) {
        extra_objects.push(...SENSES);
      }
      if (data_types.includes("skill")) {
        extra_objects.push(...SKILLS);
      }
      if (data_types.includes("weapon_keyword")) {
        extra_objects.push(...WEAPON_KEYWORDS);
      }
      data_types = data_types.filter(o => !["armor_type","language","sense","skill","weapon_keyword"].includes(o));
      api.getSetOfObjects({ data_types }).then(res => {
        if (log_it) {
          debugger;
        }
        let all: ModelBase[] = [];
        for (const dt of data_types) {
          all = [...all,...res[dt]];
        }
        setObjects([...extra_objects,...all]);
        setLoading(false);
      });
    }
    setFetched(true);
  }

  const displayType = (obj: ModelBase) => {
    if (display_type) {
      if (obj.data_type === "armor_type") {
        return " Armor";
      }
      if (obj.data_type === "weapon_keyword") {
        return " Weapons";
      }
    }
    return "";
  }
  
  if (type === "" && types.length === 0) {
    return <></>;
  } else if (!fetched || loading) {
    return <span ref={widthFinder}><LoadingBox /></span>;
  } else {
    if (log_it) {
      debugger;
    }
    const use_ids = common_util.unique_array(ids);
    const obj_finder = use_ids.map(id => {
      let obj = objects.find(o => o._id === id);
      if (!obj && objects.length > 0 && objects[0] instanceof ModelBase) {
        obj = (objects as ModelBase[]).find(o => o.variant_ids.includes(id) && o.is_true_dominant);
      }
      return obj;
    }).filter(o => o !== undefined); // objects.filter(o => ids.includes(o._id));
    if (onClick === null) {
      if (display_image) {
        return (
          <span>
            { obj_finder.map(obj => {
              if (obj) {
                return (
                  <Grid container spacing={0} direction="row" key={obj._id}>
                    { obj instanceof ModelBase && obj.image_url !== "" &&
                      <Grid
                        className='centered'
                        size={{
                          xs: 12
                        }}>
                        <img src={ obj.image_url } alt={obj.name} className='centered'
                          style={{
                            maxWidth: (width > 100 ? width : 100)
                          }}
                        />
                      </Grid>
                    }
                    <Grid
                      style={{ 
                        padding: "4px", 
                        // fontSize: "15px",
                      }}
                      className='centered header'
                      size={{
                        xs: 12
                      }}>
                      { (obj as any)[display_field] }{ displayType(obj) }
                    </Grid>
                  </Grid>
                );
              }
              return null;
            })}
          </span>
        );
      } else {
        let details = "";
        if (obj_finder.length === 0) {
          details = ids.join(", ");
        } else {
          details = obj_finder.map(o => `${(o as any)[display_field]}${ o && displayType(o) }`).join(", ");
        }
        return (
          <span>{ details }</span>
        );
      }
    } else {
      if (obj_finder.length === 0) {
        return (<>{ids.join(", ")}</>);
      } else {
        if (display_image) {
          return (
            <span style={{
              maxWidth: (width > 100 ? width : 100)
            }}>
              { obj_finder.map(obj => {
                if (obj) {
                  return (
                    <Grid container spacing={0} direction="row" key={obj._id} className="clickable" onClick={() => {
                        if (onClick && obj instanceof ModelBase) {
                          onClick(obj);
                        }
                      }}>
                      { obj instanceof ModelBase && obj.image_url !== "" &&
                        <Grid
                          className='centered'
                          size={{
                            xs: 12
                          }}>
                          <img src={ obj.image_url } alt={obj.name} className='centered'
                            style={{
                              maxWidth: (width > 100 ? width : 100)
                            }}
                          />
                        </Grid>
                      }
                      <Grid
                        style={{ 
                          padding: "4px", 
                          // fontSize: "15px",
                        }}
                        className='centered header'
                        size={{
                          xs: 12
                        }}>
                        { (obj as any)[display_field] }{ displayType(obj) }
                      </Grid>
                    </Grid>
                  );
                }
                return null;
              })}
            </span>
          );
        } else {
          return (
            <>
              { obj_finder.map((obj, key) => {
                if (obj) {
                  return (
                    <span key={obj._id}>
                      { key > 0 && ", " }
                      <span style={ onClick ? { cursor: "pointer", textDecoration: "underline" } : {}} onClick={() => {
                        if (onClick && obj instanceof ModelBase) {
                          onClick(obj);
                        }
                      }}>{ (obj as any)[display_field] }{ displayType(obj) }</span>
                    </span>
                  );
                }
                return null;
              })}
            </>
          );
        }
      }
    }
  }
}
